import React from 'react';
import { NavLink } from 'react-router-dom';

export default function PageNavigation() {
    return (
        <ul className="navigation-tabs__list">
            <li className="navigation-tabs__list-item">
                <NavLink
                    to="general"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    General
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to="system"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    System
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to="welcome"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Welcome
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to="retention"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Retention
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to="email-footer"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Email footer
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to="timings"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Timings
                </NavLink>
            </li>
        </ul>
    );
}
